define('vspot-angular/services/organizer-service',[], function () {
    'use strict';

    return ['resources.Organizer', function (Organizer) {
        return {
            /*
             * Get a list of all the organizers for a given activity.
             *
             * @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: {
             *                      loading: boolean, // Is the object actively getting data
             *                      status: boolean, // true if it worked, false on error
             *                      data: array_of_types
             *                  }
             */
            query: function (activityId) {
                return Organizer.query({ selected_activity: activityId });
            },

            get: function (activityId, organizerId) {
                return Organizer.get({ selected_activity: activityId, id: organizerId });
            },

            update: function (postData) {
                return Organizer.update(postData);
            },

            save: function (postData) {
                return Organizer.save(postData);
            },

            delete: function (activityId, organizerId) {
                return Organizer.delete({ selected_activity: activityId, id: organizerId });
            },

            setPrimary: function (activityId, organizerId) {
                return Organizer.setPrimary({ selected_activity: activityId, org_id: organizerId });
            }
        };
    }];
});

